<template>
  <div>
    <div class="VuePassword__Toggle">
      <md-icon class="plus-icon-material">person_add</md-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlusUserIcon",
};
</script>

<style lang="scss" scoped>
.plus-icon-material {
  font-size: 36px !important;
  margin-right: 0.5em;
  color: $black !important;
}
</style>
